import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { teamData } from 'data/team';

const Team = ({ activeIndex, num }: any) => {

  return (
    <div className="flex justify-center items-center bg-white w-full h-screen overflow-hidden">
      {
        teamData[activeIndex - 4]?.id === activeIndex - 4 &&
        num === teamData[activeIndex - 4].id &&
        <div className='container'>
          <div className='flex items-center gap-4'>
            <div className='flex-1 pt-12'>
              <div className='flex flex-col mb-4'>
                <motion.p
                  className='font-bold text-40 text-black leading-none'
                  transition={{ delay: 0.1 }}
                  initial={START_ANIMATION_PROPERTY}
                  whileInView={END_ANIMATION_PROPERTY}
                  viewport={VIEWPORT_PROPERTY}
                >
                  {teamData[activeIndex - 4]?.team}
                </motion.p>

                <motion.p
                  className='font-medium text-[#E7E7E7] text-40 leading-none'
                  transition={{ delay: 0.2 }}
                  initial={START_ANIMATION_PROPERTY}
                  whileInView={END_ANIMATION_PROPERTY}
                  viewport={VIEWPORT_PROPERTY}
                >
                  {teamData[activeIndex - 4]?.teamEn}
                </motion.p>
              </div>

              <div className="flex flex-col gap-5">
                {
                  teamData[activeIndex - 4]?.intro.map((item, idx) => (
                    <div className='flex flex-col gap-2' key={idx}>
                      <motion.p
                        className='font-semibold text-black text-xl'
                        transition={{ delay: 0.2 + 0.1 * idx }}
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        viewport={VIEWPORT_PROPERTY}
                      >
                        {item.title}
                      </motion.p>

                      <motion.div
                        className='flex justify-start items-center shadow-lg px-6 py-4'
                        transition={{ delay: 0.3 + 0.1 * idx }}
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        viewport={VIEWPORT_PROPERTY}
                      >
                        <p className='font-medium text-[#767676] text-base'>
                          {item.content}
                        </p>
                      </motion.div>
                    </div>
                  ))
                }
              </div>
            </div>

            <div className='flex-1 w-full'>
              <motion.img
                src={teamData[activeIndex - 4]?.img}
                alt="팀이미지"
                initial={START_ANIMATION_PROPERTY}
                whileInView={END_ANIMATION_PROPERTY}
                viewport={VIEWPORT_PROPERTY} >
              </motion.img>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default Team
